import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";

class BritishColumbiaObstetricalFileMedicalHistoryCardiovascular extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private sectionId = "MedicalHistory_Section7_Cardiovascular";
    private medicalHistoryCardiovascularOther = `${this.sectionId}_Other`;

    public render(): JSX.Element {
        const section7 = this.props.form.Section7;

        return (
            <div className="col-md-12 flex-display section7-subfield padding-xs-top">
                <div className="flex-display">
                    {this.controlRenderer.renderInlineRadio({
                        value: section7.Cardiovascular.HasCardiovascular,
                        items: this.getFalseTrueRadioOptionsWithoutLabel(),
                        onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.Cardiovascular.HasCardiovascular = value),
                        id: `${this.sectionId}_HasCardiovascular`,
                        className: "radios-one-label",
                        optionSpacing: "15px"
                    })}
                    <label className="margin-none margin-xs-left">{this.getString("CardiovascularAbbrevLabel")}</label>
                </div>
                <div className="width-100">
                    <div className="inline-flex-center">
                        {this.controlRenderer.renderCheckbox(
                            "HypertensionHTLabel",
                            section7.Cardiovascular.HasHypertension,
                            value => this.mutateCardiovascularModel(s => s.Section7.Cardiovascular.HasHypertension = value, true),
                            "margin-sm-right margin-lg-left"
                        )}
                        {this.controlRenderer.renderCheckbox(
                            "PreviewsHypertensionAbbrevLabel",
                            section7.Cardiovascular.HasPreviousHypertension,
                            value => this.mutateCardiovascularModel(s => s.Section7.Cardiovascular.HasPreviousHypertension = value, true)
                        )}
                    </div>
                    {this.renderRadioCheckboxWithLabel(
                        `${this.sectionId}_Cardiovascular_Other`,
                        "ObstetricalFile_OtherLabel",
                        section7.Cardiovascular.Other.Value,
                        value => {
                            this.mutateCardiovascularModel(
                                s => s.Section7.Cardiovascular.Other.Value = value,
                                true,
                                () => this.setFocusTextbox(value, this.medicalHistoryCardiovascularOther)
                            );
                        },
                        this.getAdditionalTextBox({
                            id: this.medicalHistoryCardiovascularOther,
                            value: section7.Cardiovascular.Other.Description,
                            onChange: value => this.mutateCardiovascularModel(s => s.Section7.Cardiovascular.Other.setDescriptionAndCheckbox(value)),
                            maxLength: this.page1FieldLimits.MedicalHistory_CardioVascular_OtherDescription.MaxChars,
                            valueClassName: "margin-xs-left"
                        }),
                        true,
                        "margin-lg-left"
                    )}
                </div>
            </div>
        );
    }

    private mutateCardiovascularModel(mutation: (state: BritishColumbiaObstetricalFileForm) => void, updateForm?: boolean, then?: () => void): void {
        this.props.mutateModelState(
            s => {
                mutation(s);
                if (s.Section7.Cardiovascular.HasCardiovascular == null)
                    s.Section7.Cardiovascular.HasCardiovascular = s.Section7.Cardiovascular.hasSelectedAnyMedicalHistoryCardiovascular();
            },
            () => {
                if (updateForm)
                    this.props.handleFormUpdate();

                then?.();
            }
        );
    }
}

export { BritishColumbiaObstetricalFileMedicalHistoryCardiovascular };
